import { Route, Routes, BrowserRouter as Router, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import "animate.css";
import 'nprogress/nprogress.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import './App.css';
import WOW from "wowjs";
import nProgress from 'nprogress';
import { toast, ToastContainer } from 'react-toastify';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollTop from './components/ScrollTop';
import Loader from './components/Loader';
import Home from './pages/Home';
import About from './pages/About';
import FindLand from './pages/FindLand';
import FindLandDetail from './pages/FindLandDetail';
import Pricing from './pages/Pricing';
import Account from './pages/Account';
import Shop from './pages/Shop';
import ShopDetail from './pages/ShopDetail';
import Cart from './pages/Cart';
import Videos from './pages/Videos';
import Contact from './pages/Contact';
import Booking from './pages/Booking';


const ONE_HOUR = 60 * 60 * 1000;
function AppContent() {
  const location = useLocation();

  const getInitialLoading = () => {
    const storedTime = sessionStorage.getItem("hasLoadedTime");

    if (!storedTime) return true;

    const now = Date.now();
    const diff = now - Number(storedTime);
    return diff > ONE_HOUR;
  };

  const [loading, setLoading] = useState(getInitialLoading());
  const [toastTriggered, setToastTriggered] = useState(false);
  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem("hasLoadedTime", Date.now());
        setToastTriggered(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  useEffect(() => {
    if (toastTriggered) {
      const timer = setTimeout(() => {
        toast.success("Welcome to Spare Lands");
        const wow = new WOW.WOW({ live: false });
        wow.init();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [toastTriggered]);

  useEffect(() => {
    nProgress.start();
    const timer = setTimeout(() => {
      nProgress.done();
    }, 700);

    return () => clearTimeout(timer);
  }, [location]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <ToastContainer position="top-center" autoClose={2000} />
      <Header />
      <ScrollTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/find-lands" element={<FindLand />} />
        <Route path="/find-land-detail" element={<FindLandDetail />} />
        <Route path="/payment-options" element={<Pricing />} />
        <Route path="/account" element={<Account />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop-detail" element={<ShopDetail />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/booking" element={<Booking />} />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;